import React from "react";
import ProfileForm from "@/components/ProfileForm";
import { appApi } from "@/lib/api";
import { toast } from "sonner";

export const StepProfile = ({ application, reload, goNext }) => {
  const handleSave = async (data) => {
    try {
      await appApi.update(application.id, data);
      toast.success("Company profile saved");
      await reload();
      goNext();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not save profile");
    }
  };
  return (
    <div>
      <h2 className="font-heading text-lg font-semibold text-navy-900">Company profile</h2>
      <p className="mb-6 text-sm text-[var(--wechr-muted-text)]">Confirm your organization details.</p>
      <ProfileForm initial={application} onSubmit={handleSave} submitLabel="Save & continue" />
    </div>
  );
};

export default StepProfile;
